import React, { useState } from "react";
import { io } from "socket.io-client";

import {
  Card,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CodeContainer from "../CodeContainer/CodeContainer";

import jwt from "jsonwebtoken";
import moment from "moment-timezone";
import Countdown from "react-countdown";

import {
  Container,
  Subtitle,
  Row,
  VaccineDetails,
  VaccineTitle,
  VaccineNotAdministrateTitle,
  VaccineSubtitle,
  VaccineDate,
  VaccineIcon,
  SyringeIcon,
} from "./Components";

import {
  CheckCircleFilled,
  CloseCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { Image, QRCode, ConfigProvider, Button, Collapse, Modal } from "antd";
import pt_BR from "antd/locale/pt_BR";
import { getUser } from "../../utils/user";
import useScreenWidth from "../../hooks/useScreenWidth";
// require("dotenv").config();
import "./index.css";

const useStyles = makeStyles(() => ({
  container: {
    width: "calc(100% - 40px)",
    borderRadius: 8,
    marginTop: 10,
  },

  accordion: {
    border: "none",
    padding: "2px 8px",
    boxShadow: "none",
    "&::before": {
      backgroundColor: "transparent",
    },

    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "0px",
    },
  },

  title: {
    fontSize: ".9rem",
    color: "#FE9201",
  },

  details: {
    padding: "0px 32px",
  },

  detailsWithCode: {
    padding: "0px",
  },

  summary: {
    margin: "0px",
  },
}));

export const VaccineCodeAccordion = ({
  t,
  qrcodeStatus,
  setQrcodeStatus,
  vaccinationCampaignsData,
}) => {
  const classes = useStyles();
  const user = getUser();

  const [qrcodeData, setQrcodeData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeQrcode, setActiveQrcode] = useState(null);
  const [qrcodeTimmer, setQrcodeTimmer] = useState(null);

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      if (
        qrcodeStatus.some((v) => v.id === activeQrcode && v.status === "active")
      ) {
        setActiveQrcode(null);
        setQrcodeStatus((prev) => {
          const newStatus = [...prev.filter((v) => v.id !== activeQrcode)];

          return newStatus;
        });
      }

      return null;
    }

    if (!completed && activeQrcode !== null) {
      // Render a countdown
      return (
        <span
          className="montserrat"
          style={{
            textTransform: "uppercase",
            letterSpacing: "0.025em",
            fontWeight: 500,
            fontSize: "0.75rem" /* 12px */,
            lineHeight: "1rem" /* 16px */,
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          Qrcode válido por: {("0" + minutes).slice(-2)}:
          {("0" + seconds).slice(-2)}
        </span>
      );
    }
  };

  const verifyIfIsExpired = (endDate: string) => {
    const date = moment(endDate, "DD/MM/YYYY").tz("America/Recife");

    const condition = moment(
      moment().tz("America/Recife").format("DD/MM/YYYY"),
      "DD/MM/YYYY"
    ).diff(date, "days");

    if (condition > 0) return true;
    return false;
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const screenWidth = useScreenWidth();

  return (
    <>
      <Card className={classes.container}>
        <ConfigProvider
          locale={pt_BR}
          theme={{ components: { Button: { controlHeight: 36 } } }}
        >
          <Accordion className={classes.accordion} expanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              classes={{ content: classes.summary }}
            >
              <Typography
                className={`${classes.title} montserrat`}
                style={{ fontWeight: 550 }}
              >
                Campanhas de vacinação
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.detailsWithCode}>
              <Box
                style={{
                  marginTop: "5px",
                  marginBottom: "10px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                  justifyContent: "center",
                }}
              >
                {vaccinationCampaignsData &&
                vaccinationCampaignsData.length > 0 ? (
                  <>
                    {vaccinationCampaignsData.map((campaign) => {
                      return (
                        <ConfigProvider
                          key={campaign?.vaccinationCampaignId}
                          theme={{
                            components: {
                              Collapse: {
                                headerBg:
                                  !campaign?.wasApplied &&
                                  !verifyIfIsExpired(campaign.endDate) &&
                                  activeQrcode !==
                                    campaign.vaccinationCampaignId
                                    ? "#fafafa"
                                    : !campaign?.wasApplied &&
                                      verifyIfIsExpired(campaign.endDate)
                                    ? "#ffdfdf"
                                    : campaign?.wasApplied
                                    ? "#dfffe4"
                                    : "#d1e2fa",
                              },
                            },
                          }}
                        >
                          <Collapse
                            accordion={true}
                            style={{
                              width: "100%",
                              marginBottom: 10,
                            }}
                            className="montserrat"
                            key={campaign.vaccinationCampaignId}
                            items={[
                              {
                                key: campaign.vaccinationCampaignId,
                                label: (
                                  <Typography
                                    className="montserrat"
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 450,
                                    }}
                                  >
                                    {!campaign?.wasApplied &&
                                    !verifyIfIsExpired(campaign.endDate) ? (
                                      `Campanha - ${
                                        campaign?.selectedSpecificDateOption
                                          ? campaign?.selectedSpecificDateOption
                                          : campaign.endDate
                                      }`
                                    ) : !campaign?.wasApplied &&
                                      verifyIfIsExpired(campaign.endDate) ? (
                                      <>
                                        Campanha -{" "}
                                        {campaign?.selectedSpecificDateOption
                                          ? campaign?.selectedSpecificDateOption
                                          : campaign.endDate}{" "}
                                        -{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                          EXPIRADA
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        Campanha -{" "}
                                        {campaign?.selectedSpecificDateOption
                                          ? campaign?.selectedSpecificDateOption
                                          : campaign.endDate}{" "}
                                        -{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                          APLICADA
                                        </span>
                                      </>
                                    )}
                                  </Typography>
                                ),
                                children: (
                                  <Box
                                    style={{
                                      marginTop: "5px",
                                      marginBottom: "10px",
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      justifyContent: "center",
                                    }}
                                    className="vaccinationCampainCard"
                                  >
                                    {!campaign?.wasApplied &&
                                      !verifyIfIsExpired(campaign.endDate) &&
                                      activeQrcode &&
                                      activeQrcode !==
                                        campaign.vaccinationCampaignId &&
                                      qrcodeData !== null && (
                                        <Typography
                                          className="montserrat"
                                          style={{
                                            marginBottom: "20px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Só é possível gerar um QRcode por vez!
                                          <br />
                                          <br />
                                          Por favor, aguarde o ultimo QRcode
                                          gerado ser expirado antes de gerar
                                          outro
                                        </Typography>
                                      )}
                                    {!campaign?.wasApplied &&
                                      verifyIfIsExpired(campaign.endDate) && (
                                        <Typography
                                          className="montserrat"
                                          style={{
                                            marginBottom: "20px",
                                            fontSize: "14px",
                                            fontWeight: 450,
                                          }}
                                        >
                                          Esta campanha de vacinação já expirou!
                                        </Typography>
                                      )}
                                    {campaign?.wasApplied && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "start",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {campaign.vrIds.map((v, index) => {
                                          return (
                                            <div
                                              key={`${v.vaccineName}-${v.lotNumber}-${index}`}
                                              style={
                                                index > 0
                                                  ? {
                                                      display: "flex",
                                                      marginTop: "15px",
                                                      // minWidth: "340px",
                                                      flexDirection: "row",
                                                    }
                                                  : {
                                                      display: "flex",
                                                      marginTop: "0px",
                                                      // minWidth: "340px",
                                                      flexDirection: "row",
                                                    }
                                              }
                                            >
                                              <VaccineIcon
                                                style={{ marginTop: 8 }}
                                              >
                                                <SyringeIcon
                                                  status={"#00A859"}
                                                />
                                              </VaccineIcon>
                                              <VaccineDetails>
                                                <VaccineTitle
                                                  className="montserrat !text-black"
                                                  style={{ fontWeight: 500 }}
                                                >
                                                  {v.vaccineName}
                                                </VaccineTitle>
                                                <VaccineSubtitle
                                                  alignText="right"
                                                  className="montserrat"
                                                >
                                                  Lote:{" "}
                                                  <span
                                                    style={{ fontWeight: 600 }}
                                                  >
                                                    {v.lotNumber}
                                                  </span>
                                                </VaccineSubtitle>
                                                <VaccineSubtitle
                                                  alignText="right"
                                                  className="montserrat"
                                                >
                                                  Data de aplicação:{" "}
                                                  <span
                                                    style={{ fontWeight: 600 }}
                                                  >
                                                    {`${moment(
                                                      v.applicationDate
                                                    ).format(
                                                      "DD/MM/YYYY"
                                                    )} às ${moment(
                                                      v.applicationDate
                                                    ).format("HH:mm")}`}
                                                  </span>
                                                </VaccineSubtitle>
                                              </VaccineDetails>
                                            </div>
                                          );
                                        })}
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            width: "100%",
                                          }}
                                        >
                                          <VaccineSubtitle
                                            alignText="right"
                                            className="montserrat vaccinationCampainCardText"
                                          >
                                            Nome do responsável pela aplicação:{" "}
                                            <span style={{ fontWeight: 600 }}>
                                              {campaign
                                                ?.responsableForApplication
                                                ?.name ?? "Sem registro"}
                                            </span>
                                          </VaccineSubtitle>
                                          <VaccineSubtitle
                                            alignText="right"
                                            className="montserrat vaccinationCampainCardText"
                                          >
                                            COREM/CRM do responsável pela
                                            aplicação:{" "}
                                            <span style={{ fontWeight: 600 }}>
                                              {campaign
                                                ?.responsableForApplication
                                                ?.healthProfessionalDocumentNumber
                                                ? campaign
                                                    ?.responsableForApplication
                                                    .healthProfessionalDocumentNumber
                                                : "Sem registro"}
                                            </span>
                                          </VaccineSubtitle>
                                        </div>
                                      </div>
                                    )}
                                    {!campaign?.wasApplied && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "start",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            marginBottom: 17,
                                            fontWeight: 450,
                                          }}
                                          className="montserrat"
                                        >
                                          Vacinas inclusas na nesta campanha
                                        </p>

                                        {campaign.vrIds.map((v, index) => {
                                          return (
                                            <div
                                              key={`${v.vaccineName}-${v.lotNumber}-${index}`}
                                              style={
                                                index > 0
                                                  ? {
                                                      display: "flex",
                                                      marginTop: "15px",
                                                      // minWidth: "340px",
                                                      flexDirection: "row",
                                                    }
                                                  : {
                                                      display: "flex",
                                                      marginTop: "0px",
                                                      // minWidth: "340px",
                                                      flexDirection: "row",
                                                    }
                                              }
                                            >
                                              <VaccineIcon>
                                                <SyringeIcon
                                                  status={"#A4A4A4"}
                                                />
                                              </VaccineIcon>
                                              <VaccineDetails>
                                                <VaccineTitle
                                                  className="montserrat"
                                                  style={{ fontWeight: 500 }}
                                                >
                                                  {v.vaccineName}
                                                </VaccineTitle>
                                                <VaccineSubtitle
                                                  alignText="right"
                                                  className="montserrat"
                                                >
                                                  Lote:{" "}
                                                  <span
                                                    style={{ fontWeight: 600 }}
                                                  >
                                                    {v.lotNumber}
                                                  </span>
                                                </VaccineSubtitle>
                                              </VaccineDetails>
                                            </div>
                                          );
                                        })}

                                        <Button
                                          style={{ marginTop: 20 }}
                                          type="primary"
                                          disabled={
                                            verifyIfIsExpired(
                                              campaign.endDate
                                            ) ||
                                            (activeQrcode &&
                                              qrcodeData !== null)
                                          }
                                          onClick={() => {
                                            setQrcodeData(
                                              jwt.sign(
                                                {
                                                  ...campaign,
                                                  userId: user._id,
                                                },
                                                `${process.env.REACT_APP_QRCODE_JWT_SECRET}`,
                                                {
                                                  expiresIn: "5m",
                                                }
                                              )
                                            );

                                            if (qrcodeStatus.length > 0) {
                                              setQrcodeStatus((prev) => {
                                                const newStatus = [
                                                  ...prev.filter(
                                                    (v) =>
                                                      v.id !==
                                                      campaign.vaccinationCampaignId
                                                  ),
                                                  {
                                                    id: campaign.vaccinationCampaignId,
                                                    status: "active",
                                                  },
                                                ];

                                                return newStatus;
                                              });
                                            } else {
                                              setQrcodeStatus([
                                                {
                                                  id: campaign.vaccinationCampaignId,
                                                  status: "active",
                                                },
                                              ]);
                                            }

                                            setQrcodeTimmer(
                                              Date.now() + 300000
                                            );
                                            setActiveQrcode(
                                              campaign.vaccinationCampaignId
                                            );

                                            showModal();
                                          }}
                                        >
                                          <p style={{ paddingBottom: "2px" }}>
                                            Gerar QRcode
                                          </p>
                                        </Button>
                                      </div>
                                    )}
                                    {activeQrcode &&
                                      activeQrcode ===
                                        campaign.vaccinationCampaignId && (
                                        <>
                                          <Modal
                                            title="QR code"
                                            open={isModalOpen}
                                            onOk={handleOk}
                                            onCancel={handleCancel}
                                            centered={true}
                                            closeIcon={false}
                                            destroyOnClose={false}
                                            maskClosable={false}
                                            closable={false}
                                            footer={null}
                                          >
                                            <Box
                                              style={{
                                                marginTop: "15px",
                                                marginBottom: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <Typography
                                                className="montserrat"
                                                style={{
                                                  fontSize: 14,
                                                  paddingRight: 15,
                                                  paddingLeft: 15,
                                                  textAlign: "start",
                                                  marginBottom: "10px",
                                                }}
                                              >
                                                Por favor, apresente este QR
                                                Code ao coordenador da campanha
                                                de vacinação de sua empresa para
                                                que seu registro de vacinação
                                                seja gerado.
                                              </Typography>

                                              <Countdown
                                                key={qrcodeTimmer.toString()}
                                                date={qrcodeTimmer}
                                                renderer={renderer}
                                              />

                                              <QRCode
                                                type="svg"
                                                id="myqrcode"
                                                value={qrcodeData}
                                                statusRender={({ status }) => {
                                                  if (status === "scanned") {
                                                    return (
                                                      <Box
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                          marginTop: 10,
                                                        }}
                                                      >
                                                        <CheckCircleFilled
                                                          style={{
                                                            color: "#52c41a",
                                                            fontSize: 48,
                                                          }}
                                                        />
                                                        <Typography
                                                          className="montserrat"
                                                          style={{
                                                            fontSize: 16,
                                                            textAlign: "start",
                                                            marginTop: "15px",
                                                          }}
                                                        >
                                                          QRcode validado!
                                                        </Typography>
                                                      </Box>
                                                    );
                                                  }

                                                  return null;
                                                }}
                                                status={
                                                  qrcodeStatus.length > 0 &&
                                                  qrcodeStatus.some(
                                                    (v) =>
                                                      v.id ===
                                                        campaign.vaccinationCampaignId &&
                                                      v.status === "scanned"
                                                  )
                                                    ? "scanned"
                                                    : "active"
                                                }
                                                style={{
                                                  width:
                                                    screenWidth <= 335
                                                      ? 315
                                                      : 350,
                                                  height:
                                                    screenWidth <= 335
                                                      ? 315
                                                      : 350,
                                                  zIndex: 1,
                                                }}
                                                className="qrcode"
                                                errorLevel="H"
                                                bgColor="#ffffff"
                                                // icon="/assets/magic-button-immunie.svg"
                                              />
                                            </Box>
                                          </Modal>
                                        </>
                                        // <Box
                                        //   style={{
                                        //     marginTop: "15px",
                                        //     marginBottom: "10px",
                                        //     display: "flex",
                                        //     alignItems: "center",
                                        //     flexDirection: "column",
                                        //     justifyContent: "center",
                                        //     justifyContent: "center",
                                        //   }}
                                        // >
                                        //   <Typography
                                        //     className="montserrat"
                                        //     style={{
                                        //       fontSize: 14,
                                        //       paddingRight: 15,
                                        //       paddingLeft: 15,
                                        //       textAlign: "start",
                                        //       marginBottom: "10px",
                                        //     }}
                                        //   >
                                        //     Por favor, apresente este QR Code ao
                                        //     coordenador da campanha de vacinação
                                        //     de sua empresa para que seu registro
                                        //     de vacinação seja gerado.
                                        //   </Typography>

                                        //   <Countdown
                                        //     key={qrcodeTimmer.toString()}
                                        //     date={qrcodeTimmer}
                                        //     renderer={renderer}
                                        //   />

                                        //   <QRCode
                                        //     type="svg"
                                        //     id="myqrcode"
                                        //     value={qrcodeData}
                                        //     statusRender={({ status }) => {
                                        //       if (status === "scanned") {
                                        //         return (
                                        //           <Box
                                        //             style={{
                                        //               display: "flex",
                                        //               flexDirection: "column",
                                        //               alignItems: "center",
                                        //               justifyContent: "center",
                                        //               marginTop: 10,
                                        //             }}
                                        //           >
                                        //             <CheckCircleFilled
                                        //               style={{
                                        //                 color: "#52c41a",
                                        //                 fontSize: 48,
                                        //               }}
                                        //             />
                                        //             <Typography
                                        //               className="montserrat"
                                        //               style={{
                                        //                 fontSize: 16,
                                        //                 textAlign: "start",
                                        //                 marginTop: "15px",
                                        //               }}
                                        //             >
                                        //               QRcode validado!
                                        //             </Typography>
                                        //           </Box>
                                        //         );
                                        //       }

                                        //       return null;
                                        //     }}
                                        //     status={
                                        //       qrcodeStatus.length > 0 &&
                                        //       qrcodeStatus.some(
                                        //         (v) =>
                                        //           v.id ===
                                        //             campaign.vaccinationCampaignId &&
                                        //           v.status === "scanned"
                                        //       )
                                        //         ? "scanned"
                                        //         : "active"
                                        //     }
                                        //     style={{
                                        //       width: 250,
                                        //       height: 250,
                                        //       zIndex: 1,
                                        //     }}
                                        //     className="qrcode"
                                        //     errorLevel="H"
                                        //     bgColor="#ffffff"
                                        //     icon="/assets/magic-button-immunie.svg"
                                        //   />
                                        // </Box>
                                      )}
                                  </Box>
                                ),
                              },
                            ]}
                          />
                        </ConfigProvider>
                      );
                    })}
                  </>
                ) : (
                  <Typography
                    className="montserrat"
                    style={{
                      fontSize: 14,
                      paddingRight: 15,
                      paddingLeft: 15,
                      textAlign: "start",
                      marginBottom: "10px",
                    }}
                  >
                    Nenhuma campanha encontrada!
                  </Typography>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
        </ConfigProvider>
      </Card>
    </>
  );
};
